import React from 'react';
import { connect } from 'react-redux';
import AlertBox, { Heading, SubHeading } from 'components/shared/AlertBox';
import { dismissUpdateRequestFailure } from 'actions/pathBuilder/actionCreators';
import addModifiers from 'utils/add_modifiers';

const ErrorModal = ({ onDismiss }) => (
  <AlertBox onDismiss={onDismiss}>
    <Heading>Uh oh!</Heading>
    <SubHeading>
      There was a problem saving your latest update.
      <br />
      please try again. If the problem continues try refreshing the page.
    </SubHeading>
    <div className="d-f jc-e ai-c mt-24">
      <button
        type="button"
        className={`ml-16 ${addModifiers('NewButton', [
          'yellow',
          'tallAndWide',
        ])}`}
        onClick={onDismiss}
        children="Ok"
      />
    </div>
  </AlertBox>
);

const mapDispatchToProps = {
  onDismiss: dismissUpdateRequestFailure,
};

export default connect(null, mapDispatchToProps)(ErrorModal);
